import './functions';
import './logic';
import './variables';
import './reducers';
import './virtuals';
import { wrapperBuilder } from './build';

export const InstitutionAccountsWrapper = wrapperBuilder.build();
